var _circle, _circle2, _circle3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 2.5,
    r: 2.5,
    fill: "#2A2A2A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 8.5,
    r: 2.5,
    fill: "#2A2A2A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 2.5,
    fill: "#2A2A2A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.76057,
    y1: 8.56105,
    x2: 13.7606,
    y2: 2.56105,
    stroke: "#2A2A2A"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.23943,
    y1: 8.56105,
    x2: 14.2394,
    y2: 14.5611,
    stroke: "#2A2A2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share.deaa899e.svg";
export { ForwardRef as ReactComponent };